var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Badge',{attrs:{"size":_vm.size,"shift":_vm.shift,"position":_vm.position,"tooltipText":"Verified Athlete","tooltipIcon":"sr-2 sr-v2-question-mark-circle text-cyan-300 verified-badge"}},[_c('BadgeVerified',{staticClass:"cursor-pointer",style:({ height: _vm.sizeInPixels + 'px' })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }